import config from '../../../app/config';
import _ from 'lodash';

// Const
export const BED_WIDTH = 300;
export const BED_HEIGHT = 150;
export const BED_MARGIN = 10;

class MapState {
    static BED_H_SCALE = config?.modules?.map?.cardScale?.height || 1;
    static BED_W_SCALE = config?.modules?.map?.cardScale?.width || 1;

    static BED_HEIGHT_INIT = BED_HEIGHT * this.BED_H_SCALE;
    static BED_WIDTH_INIT = BED_WIDTH * this.BED_W_SCALE;

    static BED_HEIGHT = BED_HEIGHT * this.BED_H_SCALE;
    static BED_WIDTH = BED_WIDTH * this.BED_W_SCALE;

    static zoom = 1;

    static extraRow = false;

    static user = null;

    /**
     * Use only to check permission on canvas map
     * Otherwise use dispatch(hasPermission(XXX)
     * @Param {string} permission - Permission to check
     */
    static userHasPermission(permission) {
        if (this.user.permissions) {
            return _.findIndex(this.user.permissions, ['code', permission]) > -1;
        } else return false;
    }

    /**
     * Use only to check permission on canvas map
     * Otherwise use dispatch(hasOneOfPermission([XXX, YYY])
     * @Param {string[]} permission - Permissions to check
     */
    static userHasOneOfPermission(permission = []) {
        let check = false;

        _.forEach(permission, (perm) => {
            if (check) return;

            check = _.findIndex(this.user.permissions, ['code', perm]) > -1;
        });
        return check;
    }

    static addPixelToHeight(pixels) {
        if (!pixels) {
            this.extraRow = false;
            this.BED_H_SCALE = config?.modules?.map?.cardScale?.height;
            this.BED_HEIGHT = BED_HEIGHT * this.BED_H_SCALE;
        } else {
            this.extraRow = true;
            let scale = (this.BED_HEIGHT_INIT + pixels) / this.BED_HEIGHT_INIT;
            this.BED_H_SCALE *= scale;
            this.BED_HEIGHT = this.BED_HEIGHT_INIT * scale;
        }
    }

    static addPixelToWidth(pixels) {
        if (!pixels) {
            this.BED_W_SCALE = config?.modules?.map?.cardScale?.width;
            this.BED_WIDTH = BED_WIDTH * this.BED_W_SCALE;
        } else {
            let scale = (this.BED_WIDTH_INIT + pixels) / this.BED_WIDTH_INIT;
            this.BED_W_SCALE *= scale;
            this.BED_WIDTH = this.BED_WIDTH_INIT * scale;
        }
    }
}

export default MapState;
